import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const deleteBankingCode = (id: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.bankCodeDelete),
    method: 'GET',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      id,
    },
  }

  console.log({ request })

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { deleteBankingCode }
